<script setup lang="ts">
import { defineProps } from "vue";

defineProps<{
  value: number | string;
}>();
</script>

<template>
  <div
    class="border-2 border-black rounded-full size-7 lg:size-9 font-bold text-base lg:text-lg flex items-center justify-center shrink-0"
  >
    {{ value }}
  </div>
</template>
